import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '@/components/common/Button';
import MainLayout from '@/components/layout/MainLayout';
import ReciboDetailModal from '@/components/recibos/ReciboDetailModal';
import reciboService from '@/services/reciboService';
import { Recibo } from '@/types/recibo';

export default function ReciboDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recibo, setRecibo] = useState<Recibo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reciboId = Number(id);

  const loadRecibo = useCallback(async () => {
    if (!Number.isFinite(reciboId) || reciboId <= 0) {
      setError('Recibo inválido');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await reciboService.getReciboById(reciboId);
      setRecibo(((res as any).data || res) as Recibo);
    } catch (err) {
      console.error('Error fetching recibo details:', err);
      setRecibo(null);
      setError('No se pudo cargar el recibo');
    } finally {
      setLoading(false);
    }
  }, [reciboId]);

  useEffect(() => {
    loadRecibo();
  }, [loadRecibo]);

  const handleClose = () => {
    navigate('/receipts', { replace: true });
  };

  return (
    <MainLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Recibo</h1>
            <p className="text-gray-600 mt-1">
              {recibo ? recibo.numero_recibo : 'Detalle del recibo'}
            </p>
          </div>
          <Button variant="secondary" onClick={() => navigate('/receipts')}>
            Volver
          </Button>
        </div>

        {loading && (
          <div className="bg-white border border-gray-200 rounded-md p-6 text-gray-600">
            Cargando recibo...
          </div>
        )}

        {!loading && error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-6">
            <h2 className="text-lg font-semibold text-red-900 mb-2">Error</h2>
            <p className="text-red-700 mb-4">{error}</p>
            <Button variant="secondary" onClick={() => navigate('/receipts')}>
              Volver a recibos
            </Button>
          </div>
        )}
      </div>

      <ReciboDetailModal
        isOpen={!!recibo && !loading}
        onClose={handleClose}
        recibo={recibo}
        onReciboUpdated={loadRecibo}
      />
    </MainLayout>
  );
}
